module.exports = __webpack_public_path__ + "images/105_4096.jpg";